import { Money } from './core.models';
import {
  PaymentAggregator,
  PaymentMethod,
  PaymentOperator
} from './payment.models';
import { FreeRequestParams } from './shared.models';

export enum ReceiptType {
  'avoir' = 'avoir',
  'normal' = 'normal',
  'purchase' = 'purchase',
  'zero' = 'zero'
}

export enum ReceiptPaymentMethod {
  CASH = 'cash',
  CARD = 'card',
  MOBILE_MONEY = 'mobile_money',
  CHECK = 'check',
  DEFERRED = 'deferred'
}

export type ReceiptSource = 'RESERVE' | 'VSDC';

export type Receipt = {
  id: string;
  venteId: string;
  receiptNumber?: string;
  aggregator?: PaymentAggregator;
  paymentReference: string;
  terminalId?: string;
  establishmentCode: string;
  merchantName: string;
  taxpayerName?: string;
  merchantNCC?: string;
  ticketDetails?: string;
  amount: Money;
  fiscalStamp?: Money;
  paymentMethod: ReceiptPaymentMethod;
  paymentOperator?: PaymentOperator;
  averagePaymentNumber?: string;
  transactionId: string;
  stickerPrice?: string;
  token?: string;
  clientNCC?: string;
  type: ReceiptType;
  clientName?: string;
  ticketNumber: string;
  receiptType: ReceiptType;
  source: ReceiptSource;
  exportDate?: string;
  saleId?: string;
  dir?: string;
  regimeId?: string;
  pc?: string;
  createdAt: string;
  updatedAt: string;
  issuedAt: string;
  // status?: string;
  certifiedAt?: string;
  totalHt?: number;
  totalTva?: number;
  // totalOtherTaxes?: number;
  metadata?: {
    migrated_from?: string;
  };
};

export type ReceiptListParams = FreeRequestParams;

export type ReceiptValidationResponse = {
  errorCode?: string;
  errorMessage?: string;
  date_heure?: string;
  agregateur?: string;
  ref_paiement?: string;
  id_terminal?: string;
  code_etablissement?: string;
  nom_marchand?: string;
  nom_contribuable?: string;
  ncc_marchand?: string;
  details_tickets?: string;
  montant?: string;
  fiscal_stamp?: string;
  mode_paiement?: string;
  operateur_paiement?: string;
  num_moyen_paiement?: string;
  id_transaction?: string;
  prix_sticker?: string;
  token?: string;
  ncc_client?: string;
  type?: string;
  name_client?: string;
  ticket_number?: string;
  receipt_type?: string;
  receipt_number?: string;
};
